import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import { MotionMask } from 'src/theme/styled'
import styled from 'styled-components'

import Icon from '../Icon'
import Picture from '../Picture'

export const Container = styled(motion.section)`
  position: relative;
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  padding-block: ${pxToRem(32)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
    flex-flow: row;
    align-items: stretch;
    gap: ${pxToRem(32)};
  }
`
export const Blockquote = styled.blockquote`
  position: relative;
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(32)};
  padding: unset;
  margin: unset;
  @media ${mq(sizes.desktop)} {
    width: 100%;
    max-width: calc(1 / 3 * 100% - ${pxToRem(32)});
    justify-content: space-between;
    text-wrap: pretty;
    &:last-child {
      max-width: calc(2 / 3 * 100%);
    }
  }
`
export const Citation = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(32)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(40)};
  }
`
export const RichTextWrapper = styled(MotionMask)`
  ${({ theme }) => theme.textStyles.m375_h2}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h2}
  }
`
export const Infos = styled(motion.footer)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(8)};
`
export const Author = styled.span`
  ${({ theme }) => theme.textStyles.m375_h4}
`
export const Status = styled.span`
  ${({ theme }) => theme.textStyles.m375_body}
`
export const Mark = styled(motion.create(Icon))`
  width: ${pxToRem(40)};
  @media ${mq(sizes.desktop)} {
    width: ${pxToRem(65)};
  }
`

export const _Picture = styled(motion.create(Picture))`
  @media ${mq(sizes.desktop)} {
    position: relative;
    flex: 1 1 auto;
    width: calc(2 / 3 * 100%);
    aspect-ratio: 16 / 9;
  }
  & img {
    @media ${mq(null, sizes.desktop)} {
      aspect-ratio: 16 / 9;
      object-fit: cover;
      object-position: top center;
    }
    @media ${mq(sizes.desktop)} {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`
